module.exports = __webpack_public_path__ + "assets/retina_ATrByOrthocenterDetailed.4760f31f6969e71f27c1063cd7332215.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_ATrByOrthocenterDetailed.png
// module id = 611
// module chunks = 0